import styled from "styled-components";

import {
  AccordionDetails,
  Menu,
  Toolbar,
  Drawer,
  IconButton,
  Accordion,
  AccordionSummary,
  MenuItem,
} from "@mui/material";
import { Link } from "react-router-dom";

export const Container = styled.div``;

export const HamburgerButton = styled(IconButton)`
  &.MuiButtonBase-root {
    margin-right: 16px;
  }
`;

export const LogoFullImg = styled.img``;

export const AppBar = styled(Toolbar)`
  justify-content: space-between;
`;

export const ToolbarLeftContainer = styled.div`
  align-items: center;
  display: flex;
`;

export const DrawerNav = styled(Drawer)`
  .MuiDrawer-paper {
    top: 64px;
    width: 240px;
  }
`;

export const UserMenuContainer = styled.div``;

export const AvatarIconButton = styled(IconButton)`
  padding: 0;
`;

export const MenuContainer = styled(Menu)`
  margin-top: 45px;
`;

export const UserMenuItem = styled(MenuItem)`
  > svg {
    margin-right: 32px;
    color: ${({ theme }) => theme.palette.grey[600]};
  }
`;

export const DrawerHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  min-height: 48px;
  padding: 0 16px;
`;

export const LogoMinImg = styled.img`
  max-height: 1.5rem;
  margin-right: 8px;
`;

export const AccordionContainer = styled(Accordion)`
  box-shadow: none !important;
  &:first-child {
    background: blue !important;
  }

  &.MuiAccordion-root.Mui-expanded {
    margin: 0;
    padding: 0;
  }

  &::before {
    display: none !important;
  }
`;

export const AccordionItemsContainer = styled(AccordionDetails)`
  &.MuiAccordionDetails-root {
    padding: 0;
  }
`;

export const AccordionTextContainer = styled.div`
  align-items: center;
  display: flex;

  > svg {
    margin-right: 32px;
    color: ${({ theme }) => theme.palette.grey[600]};
  }
`;

export const AccordionButton = styled(AccordionSummary)`
  min-height: 48px !important;
  height: 48px;
  align-items: center;
  justify-content: center;

  &:hover {
    background: ${({ theme }) => theme.palette.action.hover};
    transition: 0.2s;
  }

  .MuiAccordionSummary-content.Mui-expanded {
    margin: 0 !important;
  }
`;

export const AccordionSubButton = styled(Link)<{
  isCurrentPage?: boolean;
}>`
  min-height: 48px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  cursor: pointer;
  text-decoration: none;
  color: unset;
  background: ${({ isCurrentPage, theme }) =>
    isCurrentPage ? theme.palette.action.selected : "unset"};

  &:hover {
    background: ${({ theme }) => theme.palette.action.hover};
    transition: 0.2s;
  }
`;

export const Main = styled.main<{ isSidebarMaximized: boolean }>`
  margin-top: 63px;
  padding-left: ${({ isSidebarMaximized }) => (isSidebarMaximized ? 240 : 0)}px;
`;
